<template>
  <div class="list-wrap">
    <slot />
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ListWrap",
});
</script>
<style lang="scss" scoped>
.list-wrap {
  display: flex;
  flex-flow: column;
  border-radius: 4px;
  padding: 20px;
  :deep(.el-pagination) {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
  }
}

.list-wrap.main-content {
  margin: 10px;
}
</style>
